import React, { useReducer } from 'react';
import axios from 'axios';
import GithubContext from './GithubContext';
import GithubReducer from './GithubReducer';
import {
	SEARCH_USERS,
	CLEAR_USERS,
	GET_USER,
	GET_REPOS,
	SET_LOADING,
} from '../types';

let githubClientId;
let githubClientSecret;

if (process.env.NODE_ENV !== 'production') {
	githubClientId = process.env.REACT_APP_GITHUB_CLIENT_ID;
	githubClientSecret = process.env.REACT_APP_GITHUB_CLIENT_SECRET;
} else {
	githubClientId = process.env.GITHUB_CLIENT_ID;
	githubClientSecret = process.env.GITHUB_CLIENT_SECRET;
}

const GithubState = (props) => {
	const initialState = {
		users: [],
		user: {},
		repos: [],
		loading: false,
	};

	const [state, dispatch] = useReducer(GithubReducer, initialState);

	//Search Users
	const searchUsers = async (text) => {
		setLoading(true);

		const res = await axios.get(
			`https://api.github.com/search/users?
			q=${text}
			&client_id=${process.env.REACT_APP_GITHUB_CLIENT_ID}
			&client_secret=${process.env.REACT_APP_GITHUB_CLIENT_SECRET}
			&per_page=100`
		);

		dispatch({
			type: SEARCH_USERS,
			payload: res.data.items,
		});
	};

	//Get User
	const getUser = async (login) => {
		setLoading();
		const res = await axios.get(
			`https://api.github.com/users/${login}?
			&client_id=${githubClientId}
			&client_secret=${githubClientSecret}
			`
		);

		dispatch({
			type: GET_USER,
			payload: res.data,
		});
	};

	//Get Repos
	const getUserRepos = async (login) => {
		setLoading();
		const res = await axios.get(
			`https://api.github.com/users/${login}/repos?
			&per_page=5
			&sort=created_at&order=desc
			&client_id=${githubClientId}
			&client_secret=${githubClientSecret}
			`
		);
		dispatch({
			type: GET_REPOS,
			payload: res.data,
		});
	};
	//Clear Users
	const clearUsers = () => {
		dispatch({ type: CLEAR_USERS });
	};

	//Set Loading
	const setLoading = () =>
		dispatch({
			type: SET_LOADING,
		});

	return (
		<GithubContext.Provider
			value={{
				users: state.users,
				user: state.user,
				repos: state.repos,
				loading: state.loading,
				searchUsers,
				clearUsers,
				getUser,
				getUserRepos,
			}}
		>
			{props.children}
		</GithubContext.Provider>
	);
};
export default GithubState;
